import { BodyText, Eyebrow, FieldLabel, SubsectionTitle } from '@if/mui'
import { Card, CardContent, Divider, Link, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface Props {
  canSkipFlinks: boolean
}

const FlinksOptionBox = ({ canSkipFlinks }: Props) => {
  const { t } = useTranslation()

  const steps = [
    t('incomeVerification.bankAccountProcedure.authenticate'),
    t('incomeVerification.bankAccountProcedure.authorize'),
    t('incomeVerification.bankAccountProcedure.automated'),
  ]

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          {/* Only marked as an option when the manual card sits beside it. */}
          {canSkipFlinks && (
            <Stack spacing={1}>
              <Eyebrow>{`${t('incomeVerification.bankAccountProcedure.option')} 1`}</Eyebrow>
              <Divider />
            </Stack>
          )}
          <Stack spacing={0.5}>
            <SubsectionTitle>{t('incomeVerification.bankAccountProcedure.optionOne')}</SubsectionTitle>
            <Link component="a" href="https://flinks.com/about/" target="_blank" rel="noopener noreferrer">
              {t('incomeVerification.bankAccountProcedure.whatsFlinks')}
            </Link>
          </Stack>
          <Stack spacing={1.5}>
            {steps.map((description, index) => (
              <Stack key={description} spacing={0.25}>
                <FieldLabel>{`${t('incomeVerification.bankAccountProcedure.step')} ${index + 1}`}</FieldLabel>
                <BodyText>{description}</BodyText>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default FlinksOptionBox
